import {FormControlLabel, Radio, RadioGroup, styled, useRadioGroup} from '@mui/material'
import moment from 'moment'
import React, {FC, useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {RemoveAccents, formatter} from '../../../utils'
import * as bancas from '../redux/reducers'

interface obj {
  value: string
  label: string
}

interface Data extends Array<obj> {}

type Props = {
  data: Data
  id: string
  objectSelected?: number
  formName?: string
  tabName?: string
  defaultValue: string
  hanldeRadioValueChange?: (value: string) => void
}

const CustomRadioButton = styled(FormControlLabel)(({theme, checked}) => ({
  justifyContent: 'space-between',
  marginLeft: '0',
  marginRight: '10px',
  borderRadius: '12px',
  padding: '14px 12px',
  background: checked ? 'rgba(145, 158, 171, 0.12)' : 'none',
  // '& .MuiFormControlLabel-labelPlacementStart': {
  //     justifyContent: 'space-between',
  //     marginLeft: '0',
  //     marginRight: '0',
  //     borderRadius: '6px',
  // },
}))

const styleContent = {
  color: 'black',
}

export const RadioButtonCustom: FC<Props> = ({
  data,
  defaultValue,
  id,
  formName,
  tabName,
  objectSelected,
  hanldeRadioValueChange,
}) => {
  const [value, setValue] = useState(defaultValue)
  const dispatch = useDispatch()

  const handleSaveDataRedux = (value: string) => {
    if (formName) {
      let data = {
        key: id,
        value: value,
        tab: tabName ? tabName : '',
        form: formName,
        objectSelected: objectSelected ? objectSelected : 0,
      }
      dispatch(bancas.actions.addBancasInfors(data))
    }
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value)
    if (hanldeRadioValueChange) hanldeRadioValueChange((event.target as HTMLInputElement).value)
    handleSaveDataRedux((event.target as HTMLInputElement).value)
  }
  
  return (
    <RadioGroup
      aria-labelledby='demo-controlled-radio-buttons-group'
      name='controlled-radio-buttons-group'
      value={value}
      onChange={handleChange}
    >
      {data.map((o: any, i) => (
        <React.Fragment key={i}>
          <CustomRadioButton
            labelPlacement='start'
            value={o.code}
            control={<Radio />}
            checked={value == o.code}
            label={
              <span style={{display: 'flex'}}>
                <div style={{marginRight: '10px'}}>
                  {o.name == 'Bảo hiểm tai nạn' && (
                    <img
                      style={{width: '48px'}}
                      src={toAbsoluteUrl('/media/svg/bancas-icons/car-crash.svg')}
                      alt=''
                    />
                  )}
                  {o.name == 'Tai nạn mở rộng' && (
                    <img
                      style={{width: '48px'}}
                      src={toAbsoluteUrl('/media/svg/bancas-icons/minor-crash.svg')}
                      alt=''
                    />
                  )}
                  {(RemoveAccents(o.name).includes('suc khoe') ||
                    o.name.toLowerCase().includes('healthcare')) && (
                    <img
                      style={{width: '48px'}}
                      src={toAbsoluteUrl('/media/svg/bancas-icons/health.svg')}
                      alt=''
                    />
                  )}
                  {o.name == 'Du lịch quốc tế' && (
                    <img
                      style={{width: '48px'}}
                      src={toAbsoluteUrl('/media/svg/bancas-icons/flight.svg')}
                      alt=''
                    />
                  )}
                  {o.name == 'Du lịch nội địa' && (
                    <img
                      style={{width: '48px'}}
                      src={toAbsoluteUrl('/media/svg/bancas-icons/internation.svg')}
                      alt=''
                    />
                  )}
                  {(RemoveAccents(o.name).toLowerCase().includes('chao phi') ||
                    RemoveAccents(o.name).toLowerCase().includes('hop dong')) && (
                    <img
                      style={{
                        width: '48px',
                        filter:
                          'invert(43%) sepia(67%) saturate(2207%) hue-rotate(187deg) brightness(97%) contrast(88%)',
                      }}
                      src={toAbsoluteUrl('/media/icons/duotune/general/gen035.svg')}
                      alt=''
                    />
                  )}
                </div>
                <span
                  style={{fontSize: '14px', color: '#212B36', fontWeight: 600, lineHeight: '22px'}}
                >
                  {o.name}
                  <div
                    style={{
                      fontSize: '12px',
                      color: '#919EAB',
                      fontWeight: 400,
                      lineHeight: '18px',
                      marginTop: '4px',
                    }}
                  >
                    {o?.startTime && o?.expireTime && (
                      <p>
                        {' '}
                        Hiệu lực bảo hiểm: {moment(o.startTime).format('DD/MM/YYYY')} -{' '}
                        {moment(o.expireTime).format('DD/MM/YYYY')}
                      </p>
                    )}
                    {o?.startDate && o?.expireDate && (
                      <p>
                        {' '}
                        Hiệu lực bảo hiểm: {o.startDate} -{' '}
                        {o.expireDate}
                      </p>
                    )}
                    {o?.describe && <p>{o?.describe}</p>}
                    {o?.commodityName && (
                      <p>
                        Hàng hoá: <span style={styleContent}>{o?.commodityName}</span>
                      </p>
                    )}
                    {o?.packingTypeName && (
                      <p>
                        Đóng gói: <span style={styleContent}>{o?.packingTypeName}</span>
                      </p>
                    )}
                    {o?.shippingTypeName && (
                      <p>
                        Vận chuyển: <span style={styleContent}>{o?.shippingTypeName}</span>
                      </p>
                    )}
                    {o?.sumFee && <p>{formatter(o?.sumFee)} {' '} {o?.curencyFee}</p>}
                  </div>
                </span>
              </span>
            }
          />
        </React.Fragment>
      ))}
    </RadioGroup>
  )
}
